export const environment = {
  production: true,
  buildId: '3571465359522671',
  configFile: 'config.json',
};
